import { ComponentManager, Control } from "radpresentation.htmlclient.defaultviewextensions";
import TaskDescriptionViewModel from '@/ViewModels/Controls/TaskDescriptionViewModel';

export default class TaskDescription extends Control {
    public context: TaskDescriptionViewModel;
    private control: any;

    constructor(viewModel: any, protected element: any) {
        super(viewModel);

        this.onWidgetCreated(widget =>
            this.applyBindings(this.control, {
                controlName: 'taskdescription',
                loader: this.context.isBusy,
                controlIdent: this.identifier,
                tooltip: this.context.tooltip,
                invalid: this.context.invalidationText,
                visible: this.context.isVisible,
                styles: this.definePureComputed({
                    read: () => {
                        let styles = ['default'];
                        return styles;
                    }
                }),
                states: this.definePureComputed({
                    read: () => {
                        let states = [];
                        if (this.context.isValid() === true) {
                            states.push('valid');
                        } else {
                            states.push('invalid');
                        }
                        if (this.context.isEnabled() === true) {
                            states.push('enabled');
                        } else {
                            states.push('disabled');
                        }
                        return states;
                    }
                }),
                taskDescription: {
                    layout: 'TaskLayout',
                    isSummaryViewMode: this.context.isSummaryViewMode,
                    WFEUserTaskCompleteInformationDTO: this.context.WFEUserTaskCompleteInformationDTO,
                    context: this.context.context
                }
            }));
    }

    public getControl(): any {
        if (this.control != null) {
            return this.control;
        }
        this.control = this.element || $('<div>');
        this.widget(null);
        return this.control;
    }
}

ComponentManager.setControl('TaskDescription', TaskDescription, 'WorkflowEngineHTMLViewExtension');